// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mega-menu-container {
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  color: #023048;
  height: 46px !important;
  position: relative;
  z-index: 9999;
}
::ng-deep .mega-menu-container h4 {
  margin: 8px 0 !important;
  font-size: 18px;
  font-weight: bold;
}
::ng-deep .mega-menu-container a {
  text-decoration: none;
  color: #023048;
  display: inline-block;
}
::ng-deep .mega-menu-container a.btn {
  background: #023047;
  border: none;
  color: #fff;
  padding: 8px 32px;
  margin: 16px 0 8px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 0 !important;
}
::ng-deep .mega-menu-container ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
::ng-deep .mega-menu-container .mega-menu-desktop {
  /*** START ****************************************************************************************************/
  position: relative;
  overflow: visible;
  background: transparent;
  width: 100%;
  display: flex;
  height: 46px;
  /*** END ******************************************************************************************************/
}
::ng-deep .mega-menu-container .mega-menu-desktop .west {
  display: block;
  margin: -8px 0;
}
::ng-deep .mega-menu-container .mega-menu-desktop .west a.navbar-brand {
  padding: 0;
}
::ng-deep .mega-menu-container .mega-menu-desktop .west a.navbar-brand img {
  height: 62px;
}
::ng-deep .mega-menu-container .mega-menu-desktop .central {
  position: relative;
  display: flex;
  flex: 3 0 auto;
}
::ng-deep .mega-menu-container .mega-menu {
  display: table-row;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: transparent;
  width: max-content;
}
::ng-deep .mega-menu-container .mega-menu > ul {
  display: flex;
  max-width: 1024px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  gap: 32px;
}
::ng-deep .mega-menu-container .mega-menu > ul li {
  padding-bottom: 0.75rem;
}
::ng-deep .mega-menu-container .mega-menu > ul li:hover > .menu-title::after {
  height: 4px;
  width: 100%;
}
::ng-deep .mega-menu-container .mega-menu > ul li.targeted > .menu-title::after {
  height: 0;
  width: 0;
  transition: all 0ms ease-out;
}
::ng-deep .mega-menu-container .mega-menu .menu-title {
  color: rgba(255, 255, 255, 0.8);
  position: relative;
}
::ng-deep .mega-menu-container .mega-menu .menu-title:hover {
  color: rgb(255, 255, 255);
}
::ng-deep .mega-menu-container .mega-menu .menu-title::after {
  content: "";
  height: 0;
  width: 0;
  background: #fec530;
  position: absolute;
  left: 0;
  bottom: 0;
  transition: all 200ms ease;
}
::ng-deep .mega-menu-container .mega-menu .has-submenu:hover .submenu-container {
  display: block;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}
::ng-deep .mega-menu-container .mega-menu .submenu-container {
  z-index: 1;
  opacity: 0;
  position: fixed;
  pointer-events: none;
  left: 0;
  top: 70px;
  transform: translateY(20px);
  transition: all 200ms ease-in;
  width: 100%;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container.targeted {
  opacity: 0 !important;
  transition: all 0ms ease-out;
  z-index: 0;
  display: none !important;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu {
  background: #fff;
  padding: 16px 24px;
  box-shadow: 0 4px 50px -7px rgba(0, 0, 0, 0.2);
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu h3 {
  margin: 10px 0;
  font-size: 19px;
  font-weight: bold;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-2 {
  display: flex;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-2 .left {
  flex: 1;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-2 .right {
  flex: 2;
  text-align: right;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-2 .left img,
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-2 .right img {
  height: 300px;
  width: 100%;
  object-fit: cover;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-3 {
  display: flex;
  gap: 32px;
  /*border-top: 1px solid rgba(2, 48, 71, 0.2);*/
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-3 ul li {
  padding: 0 0 0 12px;
  margin: 12px 0;
  position: relative;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-3 ul li::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 2px;
  left: 0;
  background: #90ee90;
  transition: all 400ms ease;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu .sc-col-3 ul li:hover::before {
  width: 4px;
  background: #5ae15a;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu.sc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  text-align: center;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu.sc-grid svg {
  height: 42px;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu.sc-grid .submenu-column {
  padding: 16px;
  border-radius: 4px;
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu.sc-grid .submenu-column:hover {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
}
::ng-deep .mega-menu-container .mega-menu .submenu-container .submenu.sc-grid .submenu-column:hover svg {
  color: #e94343;
}
::ng-deep .mega-menu-container .menu-title {
  padding: 10px 16px;
  font-weight: normal;
}
::ng-deep .mega-menu-container,
::ng-deep .mega-menu-container * {
  box-sizing: border-box;
}
::ng-deep .has-submenu::after {
  content: "+";
  margin-left: -8px;
  color: rgba(255, 255, 255, 0.8);
}
::ng-deep .mega-menu-mobile {
  display: none;
}

@media (max-width: 991px) {
  ::ng-deep .p-md-1,
  ::ng-deep .p-md-2,
  ::ng-deep .p-md-3,
  ::ng-deep .p-md-4,
  ::ng-deep .p-md-5,
  ::ng-deep .p-md-6,
  ::ng-deep .p-md-7,
  ::ng-deep .p-md-8,
  ::ng-deep .p-md-9,
  ::ng-deep .p-md-10,
  ::ng-deep .p-md-11,
  ::ng-deep .p-md-12 {
    padding: 0.5rem !important;
  }
  ::ng-deep .ease-out-delay {
    transition-delay: 3s !important;
  }
  ::ng-deep .mega-menu-desktop {
    display: none !important;
  }
  ::ng-deep .mega-menu-mobile {
    position: relative;
    display: block;
    height: 0;
  }
  ::ng-deep .mega-menu-mobile h4 {
    margin: 8px 24px !important;
    font-size: 14px;
  }
  ::ng-deep .mega-menu-mobile .submenu-container {
    overflow: hidden;
    transition: max-height 300ms ease;
    max-height: 0;
  }
  ::ng-deep .mega-menu-mobile .submenu-container.active {
    max-height: 400vh;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu {
    background: #fff;
    padding: 0;
    box-shadow: unset;
    margin-top: 0;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu h3 {
    font-size: 15px;
    font-weight: normal;
    margin: 0 0 16px;
    padding: 0 16px;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-2 {
    display: flex;
    padding: 0 16px;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-2 .left {
    flex: 1;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-2 .right {
    flex: 2;
    text-align: right;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-2 .left img,
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-2 .right img {
    height: 300px;
    width: 100%;
    object-fit: cover;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-3 {
    flex-direction: column;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-3 img {
    height: 160px;
    object-fit: scale-down;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-3 ul li {
    padding: 0 0 0 12px;
    margin: 12px 0;
    position: relative;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-3 ul li::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 2px;
    left: 0;
    background: #90ee90;
    transition: all 400ms ease;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .sc-col-3 ul li:hover::before {
    width: 4px;
    background: #5ae15a;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu.sc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    text-align: center;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu.sc-grid svg {
    height: 42px;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu.sc-grid .submenu-column {
    padding: 16px;
    border-radius: 4px;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu.sc-grid .submenu-column:hover {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu.sc-grid .submenu-column:hover svg {
    color: #e94343;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .submenu-column {
    margin-bottom: 1rem;
  }
  ::ng-deep .mega-menu-mobile .submenu-container .submenu .column-menu {
    min-height: unset;
  }
  ::ng-deep .mega-menu-mobile > ul {
    margin-top: 8px;
    margin-bottom: 16px;
    background: #fff;
    max-height: calc(100vh - 62px);
    overflow-y: auto;
    transform: translateX(-130%);
    transition: all 300ms ease;
    height: auto;
  }
  ::ng-deep .mega-menu-mobile > ul > li {
    border-bottom: 1px solid #eee;
  }
  ::ng-deep .mega-menu-mobile > ul > li:hover {
    cursor: pointer;
  }
  ::ng-deep .mega-menu-mobile > ul.active {
    transform: translateX(0);
  }
  ::ng-deep .menu-header {
    display: flex;
    justify-content: space-between;
    position: relative;
    background: transparent;
    font-size: 20px;
    font-weight: bold;
    padding: 0 8px;
  }
  ::ng-deep .menu-header a.navbar-brand img {
    height: 46px;
  }
  ::ng-deep .menu-header .icons {
    position: relative;
  }
  ::ng-deep .menu-header .icons .menu-icon,
  ::ng-deep .menu-header .icons .close-icon {
    color: white;
    display: flex;
    width: 28px;
    height: 46px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 2px;
    cursor: pointer;
    pointer-events: none;
    opacity: 0;
    transition: all 200ms ease;
  }
  ::ng-deep .menu-header .icons .menu-icon.active,
  ::ng-deep .menu-header .icons .close-icon.active {
    opacity: 1;
    pointer-events: auto;
  }
  ::ng-deep .has-submenu {
    position: relative;
  }
  ::ng-deep .has-submenu::after {
    content: "+";
    color: #023048;
    position: absolute;
    top: 10px;
    right: 8px;
    font-weight: normal;
  }
}
@media (max-width: 640px) {
  ::ng-deep .mega-menu-mobile > ul {
    margin-top: 4px;
    max-height: calc(100vh - 54px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/navigation/v3.0/navbar.component.scss"],"names":[],"mappings":"AACI;EACI,kCAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAAR;AAEQ;EACI,wBAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,qBAAA;EACA,cAAA;EACA,qBAAA;AADZ;AAGY;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AADhB;AAKQ;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AAHZ;AAMQ;EACI,+GAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EAsBA,+GAAA;AAzBZ;AAKY;EACI,cAAA;EACA,cAAA;AAHhB;AAMoB;EACI,UAAA;AAJxB;AAMwB;EACI,YAAA;AAJ5B;AAUY;EACI,kBAAA;EACA,aAAA;EACA,cAAA;AARhB;AAaQ;EACI,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;AAXZ;AAaY;EACI,aAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAXhB;AAagB;EACI,uBAAA;AAXpB;AAcgB;EACI,WAAA;EACA,WAAA;AAZpB;AAegB;EACI,SAAA;EACA,QAAA;EACA,4BAAA;AAbpB;AAiBY;EACI,+BAAA;EACA,kBAAA;AAfhB;AAiBgB;EACI,yBAAA;AAfpB;AAmBY;EACI,WAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,0BAAA;AAjBhB;AAsBoB;EACI,cAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;AApBxB;AAyBY;EACI,UAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,OAAA;EACA,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,WAAA;AAvBhB;AAyBgB;EACI,qBAAA;EACA,4BAAA;EACA,UAAA;EACA,wBAAA;AAvBpB;AA0BgB;EACI,gBAAA;EACA,kBAAA;EACA,8CAAA;AAxBpB;AA0BoB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAxBxB;AA2BoB;EACI,aAAA;AAzBxB;AA2BwB;EACI,OAAA;AAzB5B;AA4BwB;EACI,OAAA;EACA,iBAAA;AA1B5B;AA6BwB;;EAEI,aAAA;EACA,WAAA;EACA,iBAAA;AA3B5B;AA+BoB;EACI,aAAA;EACA,SAAA;EACA,8CAAA;AA7BxB;AAgC4B;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;AA9BhC;AAgCgC;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,mBAAA;EACA,0BAAA;AA9BpC;AAkCoC;EACI,UAAA;EACA,mBAAA;AAhCxC;AAuCoB;EACI,aAAA;EACA,2DAAA;EACA,kBAAA;AArCxB;AAuCwB;EACI,YAAA;AArC5B;AAwCwB;EACI,aAAA;EACA,kBAAA;AAtC5B;AAwC4B;EACI,wCAAA;AAtChC;AAwCgC;EACI,cAAA;AAtCpC;AA+CQ;EACI,kBAAA;EACA,mBAAA;AA7CZ;AAiDI;;EAEI,sBAAA;AA/CR;AAkDI;EACI,YAAA;EACA,iBAAA;EACA,+BAAA;AAhDR;AAmDI;EACI,aAAA;AAjDR;;AAqDA;EAEQ;;;;;;;;;;;;IAYI,0BAAA;EAnDV;EAsDM;IACI,+BAAA;EApDV;EAuDM;IACI,wBAAA;EArDV;EAwDM;IACI,kBAAA;IACA,cAAA;IACA,SAAA;EAtDV;EAwDU;IACI,2BAAA;IACA,eAAA;EAtDd;EAyDU;IACI,gBAAA;IACA,iCAAA;IACA,aAAA;EAvDd;EAyDc;IACI,iBAAA;EAvDlB;EA0Dc;IACI,gBAAA;IACA,UAAA;IACA,iBAAA;IACA,aAAA;EAxDlB;EA0DkB;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,eAAA;EAxDtB;EA2DkB;IACI,aAAA;IACA,eAAA;EAzDtB;EA2DsB;IACI,OAAA;EAzD1B;EA4DsB;IACI,OAAA;IACA,iBAAA;EA1D1B;EA6DsB;;IAEI,aAAA;IACA,WAAA;IACA,iBAAA;EA3D1B;EA+DkB;IACI,sBAAA;EA7DtB;EA+DsB;IACI,aAAA;IACA,sBAAA;EA7D1B;EAiE0B;IACI,mBAAA;IACA,cAAA;IACA,kBAAA;EA/D9B;EAiE8B;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,OAAA;IACA,mBAAA;IACA,0BAAA;EA/DlC;EAmEkC;IACI,UAAA;IACA,mBAAA;EAjEtC;EAwEkB;IACI,aAAA;IACA,2DAAA;IACA,kBAAA;EAtEtB;EAwEsB;IACI,YAAA;EAtE1B;EAyEsB;IACI,aAAA;IACA,kBAAA;EAvE1B;EAyE0B;IACI,wCAAA;EAvE9B;EAyE8B;IACI,cAAA;EAvElC;EA6EkB;IACI,mBAAA;EA3EtB;EA8EkB;IACI,iBAAA;EA5EtB;EAiFU;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,0BAAA;IACA,YAAA;EA/Ed;EAiFc;IACI,6BAAA;EA/ElB;EAiFkB;IACI,eAAA;EA/EtB;EAmFc;IACI,wBAAA;EAjFlB;EAsFM;IACI,aAAA;IACA,8BAAA;IACA,kBAAA;IACA,uBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;EApFV;EAwFkB;IACI,YAAA;EAtFtB;EA2FU;IACI,kBAAA;EAzFd;EA2Fc;;IAEI,YAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,oBAAA;IACA,UAAA;IACA,0BAAA;EAzFlB;EA2FkB;;IACI,UAAA;IACA,oBAAA;EAxFtB;EA8FM;IACI,kBAAA;EA5FV;EA8FU;IACI,YAAA;IACA,cAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;EA5Fd;AACF;AAiGA;EAGY;IACI,eAAA;IACA,8BAAA;EAjGd;AACF","sourcesContent":["::ng-deep {\n    .mega-menu-container {\n        font-family: \"Poppins\", sans-serif;\n        font-size: 15px;\n        color: #023048;\n        height: 46px !important;\n        position: relative;\n        z-index: 9999;\n\n        h4 {\n            margin: 8px 0 !important;\n            font-size: 18px;\n            font-weight: bold;\n        }\n\n        a {\n            text-decoration: none;\n            color: #023048;\n            display: inline-block;\n\n            &.btn {\n                background: #023047;\n                border: none;\n                color: #fff;\n                padding: 8px 32px;\n                margin: 16px 0 8px;\n                cursor: pointer;\n                font-weight: bold;\n                border-radius: 0 !important;\n            }\n        }\n\n        ul {\n            padding: 0;\n            margin: 0;\n            list-style: none;\n        }\n\n        .mega-menu-desktop {\n            /*** START ****************************************************************************************************/\n            position: relative;\n            overflow: visible;\n            background: transparent;\n            width: 100%;\n            display: flex;\n            height: 46px;\n\n            .west {\n                display: block;\n                margin: -8px 0;\n\n                a {\n                    &.navbar-brand {\n                        padding: 0;\n\n                        img {\n                            height: 62px;\n                        }\n                    }\n                }\n            }\n\n            .central {\n                position: relative;\n                display: flex;\n                flex: 3 0 auto;\n            }\n            /*** END ******************************************************************************************************/\n        }\n\n        .mega-menu {\n            display: table-row;\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            margin: 0 auto;\n            background: transparent;\n            width: max-content;\n\n            > ul {\n                display: flex;\n                max-width: 1024px;\n                margin: 0 auto;\n                justify-content: center;\n                align-items: center;\n                gap: 32px;\n\n                li {\n                    padding-bottom: .75rem;\n                }\n\n                li:hover > .menu-title::after {\n                    height: 4px;\n                    width: 100%;\n                }\n\n                li.targeted > .menu-title::after {\n                    height: 0;\n                    width: 0;\n                    transition: all 0ms ease-out;\n                }\n            }\n\n            .menu-title {\n                color: rgba(255, 255, 255, 0.8);\n                position: relative;\n\n                &:hover {\n                    color: rgba(255, 255, 255, 1);\n                }\n            }\n\n            .menu-title::after {\n                content: \"\";\n                height: 0;\n                width: 0;\n                background: #fec530;\n                position: absolute;\n                left: 0;\n                bottom: 0;\n                transition: all 200ms ease;\n            }\n\n            .has-submenu {\n                &:hover {\n                    .submenu-container {\n                        display: block;\n                        opacity: 1;\n                        pointer-events: auto;\n                        transform: translateY(0);\n                    }\n                }\n            }\n\n            .submenu-container {\n                z-index: 1;\n                opacity: 0;\n                position: fixed;\n                pointer-events: none;\n                left: 0;\n                top: 70px;\n                transform: translateY(20px);\n                transition: all 200ms ease-in;\n                width: 100%;\n\n                &.targeted {\n                    opacity: 0 !important;\n                    transition: all 0ms ease-out;\n                    z-index: 0;\n                    display: none !important;\n                }\n\n                .submenu {\n                    background: #fff;\n                    padding: 16px 24px;\n                    box-shadow: 0 4px 50px -7px rgba(0, 0, 0, 0.2);\n\n                    h3 {\n                        margin: 10px 0;\n                        font-size: 19px;\n                        font-weight: bold;\n                    }\n\n                    .sc-col-2 {\n                        display: flex;\n\n                        .left {\n                            flex: 1;\n                        }\n\n                        .right {\n                            flex: 2;\n                            text-align: right;\n                        }\n\n                        .left img,\n                        .right img {\n                            height: 300px;\n                            width: 100%;\n                            object-fit: cover;\n                        }\n                    }\n\n                    .sc-col-3 {\n                        display: flex;\n                        gap: 32px;\n                        /*border-top: 1px solid rgba(2, 48, 71, 0.2);*/\n\n                        ul {\n                            li {\n                                padding: 0 0 0 12px;\n                                margin: 12px 0;\n                                position: relative;\n\n                                &::before {\n                                    content: \"\";\n                                    position: absolute;\n                                    height: 100%;\n                                    width: 2px;\n                                    left: 0;\n                                    background: #90ee90;\n                                    transition: all 400ms ease;\n                                }\n\n                                &:hover {\n                                    &::before {\n                                        width: 4px;\n                                        background: #5ae15a;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    &.sc-grid {\n                        display: grid;\n                        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n                        text-align: center;\n\n                        svg {\n                            height: 42px;\n                        }\n\n                        .submenu-column {\n                            padding: 16px;\n                            border-radius: 4px;\n\n                            &:hover {\n                                box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\n\n                                svg {\n                                    color: #e94343;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .menu-title {\n            padding: 10px 16px;\n            font-weight: normal;\n        }\n    }\n\n    .mega-menu-container,\n    .mega-menu-container * {\n        box-sizing: border-box;\n    }\n\n    .has-submenu::after {\n        content: \"+\";\n        margin-left: -8px;\n        color: rgba(255, 255, 255, 0.8);\n    }\n\n    .mega-menu-mobile {\n        display: none;\n    }\n}\n\n@media (max-width: 991px) {\n    ::ng-deep {\n        .p-md-1,\n        .p-md-2,\n        .p-md-3,\n        .p-md-4,\n        .p-md-5,\n        .p-md-6,\n        .p-md-7,\n        .p-md-8,\n        .p-md-9,\n        .p-md-10,\n        .p-md-11,\n        .p-md-12 {\n            padding: .5rem !important;\n        }\n\n        .ease-out-delay {\n            transition-delay: 3s !important;\n        }\n\n        .mega-menu-desktop {\n            display: none !important;\n        }\n\n        .mega-menu-mobile {\n            position: relative;\n            display: block;\n            height: 0;\n\n            h4 {\n                margin: 8px 24px !important;\n                font-size: 14px;\n            }\n\n            .submenu-container {\n                overflow: hidden;\n                transition: max-height 300ms ease;\n                max-height: 0;\n\n                &.active {\n                    max-height: 400vh;\n                }\n\n                .submenu {\n                    background: #fff;\n                    padding: 0;\n                    box-shadow: unset;\n                    margin-top: 0;\n\n                    h3 {\n                        font-size: 15px;\n                        font-weight: normal;\n                        margin: 0 0 16px;\n                        padding: 0 16px;\n                    }\n\n                    .sc-col-2 {\n                        display: flex;\n                        padding: 0 16px;\n\n                        .left {\n                            flex: 1;\n                        }\n\n                        .right {\n                            flex: 2;\n                            text-align: right;\n                        }\n\n                        .left img,\n                        .right img {\n                            height: 300px;\n                            width: 100%;\n                            object-fit: cover;\n                        }\n                    }\n\n                    .sc-col-3 {\n                        flex-direction: column;\n\n                        img {\n                            height: 160px;\n                            object-fit: scale-down;\n                        }\n\n                        ul {\n                            li {\n                                padding: 0 0 0 12px;\n                                margin: 12px 0;\n                                position: relative;\n\n                                &::before {\n                                    content: \"\";\n                                    position: absolute;\n                                    height: 100%;\n                                    width: 2px;\n                                    left: 0;\n                                    background: #90ee90;\n                                    transition: all 400ms ease;\n                                }\n\n                                &:hover {\n                                    &::before {\n                                        width: 4px;\n                                        background: #5ae15a;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    &.sc-grid {\n                        display: grid;\n                        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n                        text-align: center;\n\n                        svg {\n                            height: 42px;\n                        }\n\n                        .submenu-column {\n                            padding: 16px;\n                            border-radius: 4px;\n\n                            &:hover {\n                                box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);\n\n                                svg {\n                                    color: #e94343;\n                                }\n                            }\n                        }\n                    }\n\n                    .submenu-column {\n                        margin-bottom: 1rem;\n                    }\n\n                    .column-menu {\n                        min-height: unset;\n                    }\n                }\n            }\n\n            > ul {\n                margin-top: 8px;\n                margin-bottom: 16px;\n                background: #fff;\n                max-height: calc(100vh - 62px);\n                overflow-y: auto;\n                transform: translateX(-130%);\n                transition: all 300ms ease;\n                height: auto;\n\n                > li {\n                    border-bottom: 1px solid #eee;\n\n                    &:hover {\n                        cursor: pointer;\n                    }\n                }\n\n                &.active {\n                    transform: translateX(0);\n                }\n            }\n        }\n\n        .menu-header {\n            display: flex;\n            justify-content: space-between;\n            position: relative;\n            background: transparent;\n            font-size: 20px;\n            font-weight: bold;\n            padding: 0 8px;\n\n            a {\n                &.navbar-brand {\n                    img {\n                        height: 46px;\n                    }\n                }\n            }\n\n            .icons {\n                position: relative;\n\n                .menu-icon,\n                .close-icon {\n                    color: white;\n                    display: flex;\n                    width: 28px;\n                    height: 46px;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    padding: 2px;\n                    cursor: pointer;\n                    pointer-events: none;\n                    opacity: 0;\n                    transition: all 200ms ease;\n\n                    &.active {\n                        opacity: 1;\n                        pointer-events: auto;\n                    }\n                }\n            }\n        }\n\n        .has-submenu {\n            position: relative;\n\n            &::after {\n                content: \"+\";\n                color: #023048;\n                position: absolute;\n                top: 10px;\n                right: 8px;\n                font-weight: normal;\n            }\n        }\n    }\n}\n\n@media (max-width: 640px) {\n    ::ng-deep {\n        .mega-menu-mobile {\n            > ul {\n                margin-top: 4px;\n                max-height: calc(100vh - 54px);\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
